import {
  createSearchParams,
  NavigateFunction,
  useNavigate,
} from "react-router-dom";

import { BOOKING_ACTIONS } from "../../store/onlineBooking";
import BookingForm from "../../components/Layouts/BookingForm/BookingForm";
import { PageConfigGetters } from "../../store/PageConfigurations/getters";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import CollapsibleNavbar from "../../components/Layouts/ReservedAreaDashboard/CollapseNavbar";
import { formatTheme } from "../../config/MuiColorThemes";
import createTheme from "@mui/material/styles/createTheme";
import ThemeProvider from "@mui/material/styles/ThemeProvider";
import { requestParentResize } from "../../helpers/iframeSource";
import { BookingApi } from "../../API/Apis/BookingApi";
function HomePage(): JSX.Element {
  const dynamicPalette = formatTheme();
  const dynamicTheme = createTheme(dynamicPalette);
  const BookingFormConfig = PageConfigGetters.getBookingFormConfig();
  const dispatch = useDispatch();
  const routerNavigation: NavigateFunction = useNavigate();
  useEffect(() => {
    dispatch(BOOKING_ACTIONS.setSessionExpiryTime(0));
  }, []);
  const isDesktopScreen = window.innerWidth >= 1310;
  const [showBooking, setShowBooking] = useState(false);
  const [userId] = useState(localStorage.getItem("userID"));
  useEffect(() => {
    if (userId != null && userId != "null" && userId != "") {
      BookingApi.getUserProfileByUserId(parseInt(userId)).then((e) => {
        if (e.data.status == "Not Found") {
          setShowBooking(false);
        } else {
          setShowBooking(true);
        }
      });
    } else {
      setShowBooking(false);
    }
  }, [userId]);
  const isSmallScreen = window.innerWidth <= 768;
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const toggleDrawer = (isOpen) => {
    setIsDrawerOpen(isOpen);
  };

  useEffect(() => {
    const desktopHeight = showBooking ? null : 680;
    requestParentResize(isDesktopScreen, desktopHeight, 330);
  }, []);
  const handleSubmit = (e) => {
    dispatch(BOOKING_ACTIONS.setBookingInformation({ ...e }));
    const searchParams = createSearchParams({
      dropOffDateAndTime: e.dropOffDateAndTime,
      pickUpDateAndTime: e.pickUpDateAndTime,
      pickUpLocation: e.pickUpLocationDetails.code,
      dropOffLocation: e.dropOffLocationDetails.code,
      pickUpLocationName: e.pickUpLocationDetails.name,
      dropOffLocationName: e.dropOffLocationDetails.name,
      reservationSource: e.reservationSource,
      showPics: "true",
      showOptionalImage: "true",
      showVehicleParameter: "true",
      showVehicleExtraImage: "true",
      showBookingDiscount: "true",
      longitude: e.pickUpLocationDetails.longitude,
      latitude: e.pickUpLocationDetails.latitude,
      dealerId: e?.pickUpLocationDetails?.dealerId,
    }).toString();
    routerNavigation("/choose/vehicle?" + searchParams);
  };
  const getHeadingStyle = (
    isSmallScreen: boolean,
    showBooking: boolean
  ): React.CSSProperties => ({
    fontSize: isSmallScreen ? "26px" : "65px",
    marginTop: isSmallScreen ? (showBooking ? "135px" : "78px") : "238px",
    fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
    lineHeight: isSmallScreen ? "1.2" : "normal",
    whiteSpace: "nowrap",
  });
  return (
    <ThemeProvider theme={dynamicTheme}>
      <div className="min-h-screen flex flex-col bg-black">
        <div
          className={`banner ${
            isSmallScreen ? "small" : "large zoom-proof-wrapper"
          } ${showBooking ? "showBooking" : ""}`}
          style={{
            backgroundImage: `url('/assets/images/main_banner_image-min.webp')`,
          }}
        >
          <div
            style={{
              maxWidth: isSmallScreen ? "80%" : "",
            }}
          >
            <>
              <div style={{ color: "white", display: "none" }}>
                <CollapsibleNavbar
                  isDrawerOpen={isDrawerOpen}
                  toggleDrawer={toggleDrawer}
                />
              </div>
            </>
            <h1 style={getHeadingStyle(isSmallScreen, showBooking)}>
              Noleggio flessibile con Mercedes-Benz
            </h1>

            <p
              className={isSmallScreen ? "paragraph-small" : "paragraph-large"}
            >
              Non farti guidare dalle stelle. Scegline una. Seleziona il
              concessionario
            </p>
            <p
              className={isSmallScreen ? "paragraph-small" : "paragraph-large"}
            >
              Mercedes-Benz più vicino, la durata del noleggio e scopri le
              vetture disponibili.
            </p>
          </div>
        </div>
        <section
          className="h-full box-border flex flex-col md:px-12 px-4"
          style={{
            marginTop: isSmallScreen ? "0px" : "-138px",
            background: isSmallScreen ? "black" : "undefined",
          }}
        >
          {/* {console.log("showBooking", showBooking)} */}
          {showBooking && (
            <div className="flex">
              <div className="w-[100%] pb-12 h-[100%]">
                {BookingFormConfig.fields && (
                  <BookingForm
                    className="grow mt-10"
                    options={BookingFormConfig.fields || []}
                    onSubmit={handleSubmit}
                  />
                )}
              </div>
            </div>
          )}
          {/* <div className="flex">
            <div className="w-[100%] pb-12 h-[100%]">
              {BookingFormConfig.fields && (
                <BookingForm
                  className="grow mt-10"
                  options={BookingFormConfig.fields || []}
                  onSubmit={handleSubmit}
                />
              )}
            </div>
          </div> */}
        </section>
      </div>
    </ThemeProvider>
  );
}
export default HomePage;
